import "./Navbar.css";
import logo from "./blackdoorLogo2Edited.jpg"

import './Navbar.css'; // Import CSS file

const Navbar = (props) => {
  return (
    <nav className="navbar">
      <div className="navbar-icon">
        {/* Replace with your icon */}
        {/* <img src="your-icon-url" alt="icon" className="icon" /> */}
        <img className="nav-logo" src={logo} alt="BlackDoor logo" />
      </div>
      <ul className="navbar-list">
        <li><a href="#home">Home</a></li>
        <li><a href="#howWeWork" className="nav-hide">How We Work</a></li>
        <li><a href="#products">Products</a></li>
        <li><a href="#contact" className="nav-hide nav-demo"  onClick={() => props.isForm(true)}>Schedule a demo</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
